import { Link } from "react-router-dom";
import { useTranslation } from "@/i18n";

export default function Footer() {
  const { t } = useTranslation();

  const links = [
    { label: t("footer.terms"), to: "/conditions-utilisation", id: "terms" },
    { label: t("footer.privacy"), to: "/vie-privee", id: "privacy" },
    { label: t("footer.contactUs"), to: "/#contact", id: "contact" },
    { label: t("footer.backoffice"), to: "/admin/login", id: "backoffice" },
  ];

  return (
    <footer className="bg-ink border-t border-gold/10 py-14" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
          <div className="flex items-center gap-3">
            <img src="/logo-mark.png" alt="e².law" className="w-9 h-9" />
            <div>
              <p className="font-serif text-lg text-[#FAF8F5]">
                e²<span className="text-gold">.law</span>
              </p>
              <p className="text-[10px] uppercase tracking-[0.25em] text-[#9BA1B0] font-mono">
                {t("footer.tagline")}
              </p>
            </div>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-nav">
            {links.map((l) => (
              <Link
                key={l.id}
                to={l.to}
                data-testid={`footer-link-${l.id}`}
                className="text-xs text-[#9BA1B0] hover:text-gold transition-colors duration-300 tracking-wide"
              >
                {l.label}
              </Link>
            ))}
            <button
              onClick={() => {
                localStorage.removeItem("e2law-consent");
                localStorage.removeItem("e2law-consent-v2");
                window.dispatchEvent(new Event("e2law-consent-reset"));
              }}
              data-testid="footer-link-cookies"
              className="text-xs text-[#9BA1B0] hover:text-gold transition-colors duration-300 tracking-wide"
            >
              Cookies
            </button>
          </nav>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-[#9BA1B0]" data-testid="footer-copyright">
            © 2026 e².law • BE0847.833.547 — {t("footer.rights")}.
          </p>
          <p className="text-xs text-[#9BA1B0] font-mono tracking-widest uppercase">
            {t("footer.address")}
          </p>
        </div>
      </div>
    </footer>
  );
}
